const SUBSCRIBER_DISPLAY_LOCALE = "en-US";
const ROUNDED_SUBSCRIBER_THRESHOLD = 1000;

export function formatYoutubeSubscriberCount(count: number): string {
  const formatted = new Intl.NumberFormat(SUBSCRIBER_DISPLAY_LOCALE).format(
    count,
  );
  return count >= ROUNDED_SUBSCRIBER_THRESHOLD ? `${formatted}+` : formatted;
}
